<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/vNom2p/tc-custom/9798368820279.jpg?1745395954518" alt="This image is the cover for the book Deadly Tales Of The Gunslinger Spawn #3, DEADLY TALES OF THE GUNSLINGER SPAWN"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Deadly Tales Of The Gunslinger Spawn #3, DEADLY TALES OF THE GUNSLINGER SPAWN
      </h1>
      <p class="bookDescription body article font2">
        <p>In under 48 hours, the Gunslinger's life underwent an unexpected transformation, granting him extraordinary powers and newfound abilities. Simultaneously, it unleashed a hidden realm of existence that had eluded him until now, akin to opening Pandora's box.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jimmy Palmiotti, Patric Reynolds
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Image Comics
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2e50b5de